<div class="cm-container">
  <div class="rates-block">
    <div class="cm-component cm-page-header">
      <h1 class="cm-page-header-title">Latest Rates</h1>
      <div class="cm-page-header-subtitle"></div>
      <div class="cm-page-header-posteddate"></div>
    </div>
    <div class="cm-block cm-product-rates cm-product-rates--all">
      <div class="cm-product-rates-list">
        <a
          *ngFor="let ratecapInfo of ratecapInfos"
          href="{{ ratecapInfo.rateCapUrl }}"
          target="{{ ratecapInfo.target }}"
          class="cm-product-rates-item"
        >
          <div class="cm-product-rates-content" tabindex="-1">
            <div class="cm-product-rates-copy">
              <strong class="cm-product-rates-title">
                <span class="cm-product-rates-title-span">
                  {{ ratecapInfo.rateCapName }}
                </span>
                &nbsp;&nbsp;<span class="cm-product-rates-linktype">{{ ratecapInfo.fileType }}</span>
              </strong>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
